import { EntrepotChangedEvent } from "events/Event";
import { JSX, useEffect, useState } from "react";

export function Maintenance(): JSX.Element {
  const [ entrepot, setEntrepot] = useState<number>(-1);
 
  useEffect(() => {
    EntrepotChangedEvent.subscribe((e) => { 
      console.log('Maintenance', 'ui:entrepot.changed', e);
      setEntrepot(e);
    });
  }, []);  
  return <div>Maintenance {entrepot}</div>;
}
